module.exports = __webpack_public_path__ + "static/media/final.b4990c22.jpg";